<!-- src/app/core/pwa/components/pwa-prompt/pwa-prompt.component.html -->

<ion-modal [isOpen]="showPrompt" [canDismiss]="!isInstalling" (didDismiss)="onDidDismiss()" class="pwa-install-modal">
  <ng-template>
    <div class="max-h-[85vh] overflow-y-auto bg-canvas px-5 pt-5 pb-[calc(var(--ion-safe-area-bottom,0px)_+_1.25rem)]">

      <!-- Cabecera -->
      <div class="flex items-start gap-3">
        <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <ion-icon name="phone-portrait-outline" class="text-xl"></ion-icon>
        </span>
        <div class="min-w-0 flex-1 pt-0.5">
          <h2 class="text-[15px] font-semibold tracking-tight text-neutral-900">Instalar Agrofuturo CRM</h2>
          <p class="mt-0.5 text-[12px] leading-snug text-neutral-600">Acceso rápido desde la pantalla de inicio, también sin conexión.</p>
        </div>
        <button type="button" (click)="onClose()" [disabled]="isInstalling" aria-label="Cerrar"
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-neutral-500 transition-colors hover:bg-neutral-200/60 hover:text-neutral-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:opacity-50">
          <ion-icon name="close-outline" class="text-lg"></ion-icon>
        </button>
      </div>

      <!-- Beneficios -->
      <p class="mt-5 font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-neutral-600">Beneficios</p>
      <div class="mt-2 divide-y divide-neutral-200 rounded-xl border border-neutral-200 bg-white">
        <div class="flex items-center gap-3 px-4 py-3">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-base text-primary">
            <ion-icon name="flash-outline"></ion-icon>
          </span>
          <div class="min-w-0 flex-1">
            <p class="text-[13px] font-semibold tracking-tight text-neutral-900">Acceso más rápido</p>
            <p class="text-[11px] leading-snug text-neutral-600">Abre la app directo desde la pantalla de inicio.</p>
          </div>
        </div>
        <div class="flex items-center gap-3 px-4 py-3">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-base text-primary">
            <ion-icon name="phone-portrait-outline"></ion-icon>
          </span>
          <div class="min-w-0 flex-1">
            <p class="text-[13px] font-semibold tracking-tight text-neutral-900">Experiencia de app</p>
            <p class="text-[11px] leading-snug text-neutral-600">Se abre en ventana propia, sin barra del navegador.</p>
          </div>
        </div>
        <div class="flex items-center gap-3 px-4 py-3">
          <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-base text-primary">
            <ion-icon name="sync-outline"></ion-icon>
          </span>
          <div class="min-w-0 flex-1">
            <p class="text-[13px] font-semibold tracking-tight text-neutral-900">Siempre actualizada</p>
            <p class="text-[11px] leading-snug text-neutral-600">Recibe las últimas mejoras automáticamente.</p>
          </div>
        </div>
      </div>

      <!-- Acciones -->
      <div class="mt-5 flex gap-2.5">
        <button type="button" (click)="onDismiss()" [disabled]="isInstalling"
          class="flex-1 rounded-xl border border-neutral-300 bg-white px-4 py-3 text-[13px] font-medium text-neutral-700 transition-colors hover:border-neutral-400 hover:text-neutral-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:opacity-50">
          Ahora no
        </button>
        <button type="button" (click)="onInstall()" [disabled]="isInstalling"
          class="flex flex-1 items-center justify-center gap-2 rounded-xl bg-primary px-4 py-3 text-[13px] font-semibold text-white transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 disabled:opacity-60">
          @if (isInstalling) {
            <span class="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" aria-hidden="true"></span>
            <span>Instalando…</span>
          } @else {
            <ion-icon name="download-outline" class="text-base"></ion-icon>
            <span>Instalar</span>
          }
        </button>
      </div>

    </div>
  </ng-template>
</ion-modal>
